import * as React from "react"
import LinkedInIconLettersOnly from "../Icon/LinkedInIconLettersOnly"
import cs from "classnames"
import { LinearProgress } from "@mui/material"

interface Props {
  className?: string
  isLoading?: boolean

  onClick?(): void
}

export const LinkedinLoginButton = ({ className, isLoading, onClick }: Props) => {
  return (
    <button
      className={cs(
        "tmb-bg-[#0A66C2] tmb-border-none tmb-flex tmb-items-center tmb-justify-center tmb-rounded-[32px] tmb-w-fit tmb-py-2 tmb-relative tmb-w-full tmb-cursor-pointer hover:tmb-bg-[#245f9b] tmb-relative",
        { ["tmb-opacity-55 tmb-pointer-events-none"]: isLoading },
        className
      )}
      onClick={onClick}
    >
      <LinkedInIconLettersOnly className="tmb-absolute tmb-left-3 tmb-w-6 tmb-h-auto tmb-ml-1 tmb-mb-1" />

      <span className="tmb-text-white tmb-font-semibold tmb-text-lg tmb-whitespace-nowrap">Sign In With LinkedIn</span>

      {isLoading && <LinearProgress className="tmb-h-1 tmb-left-4 tmb-right-4 tmb-absolute -tmb-bottom-2" />}
    </button>
  )
}
